@if (completed()) {
  <app-progress-upload-toasts-item-completed
    [class.standalone]="standalone()"
    [standalone]="standalone()"
    [toastId]="toast().id"
    [gallery]="toast().gallery"
    [failedUploads]="failedUploads()"
    [uploads]="uploads()"
    [uploadedAssetCount]="uploadedAssets().length"
    [uploadedTotalSize]="uploadedTotalSize()"
  ></app-progress-upload-toasts-item-completed>
} @else {
  <div class="item-header" [class.minimized]="minimized()" [class.standalone]="standalone()">
    <div class="header-icon">
      <app-circle-progress-bar
        [progress]="uploadProgress()"
        [size]="62"
        [strokeWidth]="12"
        [noBackgroundCircle]="true"
      ></app-circle-progress-bar>
      <img src="/assets/animations/upload-arrow-only.svg" alt="" />
    </div>

    <div class="header-info">
      <div class="uploading-title">Uploading {{ uploads().length }} Assets</div>
      <div class="uploading-stats">
        {{ totalSize() | dataUnitsBigInt }}
        @if (remainingTime(); as remainingTime) {
          <span> · {{ remainingTime | timeRemaining }} remaining</span>
        }
      </div>
    </div>

    @if (!minimized()) {
      <button
        appButton
        name="cancel"
        location="progress-upload-toasts-item"
        shape="round"
        height="1"
        color="simple-gray-60"
        appTooltip="Cancel Upload"
        [iconButton]="true"
        (click)="showCancelUploadDialog()"
      >
        <app-svg src="/assets/icons/stop.svg"></app-svg>
      </button>
    }

    @if (!standalone()) {
      <button
        appButton
        name="toggle-minimize"
        location="progress-upload-toasts-item"
        shape="round"
        height="1"
        color="simple-gray-60"
        [appTooltip]="minimized() ? 'Open' : 'Minimize'"
        [iconButton]="true"
        (click)="minimized.set(!minimized())"
      >
        @if (minimized()) {
          <app-svg src="/assets/icons/chevron-expand.svg"></app-svg>
        } @else {
          <app-svg src="/assets/icons/chevron-collapse.svg"></app-svg>
        }
      </button>
    }
  </div>

  @if (!minimized()) {
    <div class="uploads" [class.standalone]="standalone()">
      @if (failedUploads().length) {
        <div class="upload-error-info" (click)="showFailedUploads()">
          <app-svg src="/assets/icons/alert-circle.svg"></app-svg>
          <div class="error-details">
            {{ failedUploads().length }}
            @if (failedUploads().length !== 1) {
              assets
            } @else {
              asset
            }
            failed to upload.
          </div>

          <button
            appButton
            name="error-details"
            location="progress-upload-toasts-item"
            color="simple-orange"
            shape="round"
            height="0"
            size="1"
          >
            Details
          </button>
        </div>
      }

      @for (upload of uploads() | uploadOrder; track upload.id) {
        <div class="upload">
          <div class="upload-info">
            <div class="uploading-asset-name">{{ upload.file.name }}</div>
            <div class="uploading-asset-status">
              @if (upload.status === 'done') {
                Completed
              } @else if (upload.status === 'started') {
                Uploading · {{ upload.file.size | dataUnitsBigInt }}
              } @else if (upload.status === 'error') {
                Failed
              } @else {
                Waiting...
              }
            </div>
          </div>
          <div class="upload-icon" [class.done]="upload.status === 'done'">
            @if (upload.status === 'done') {
              <app-animated-svg src="/assets/animations/success-600ms.svg"></app-animated-svg>
            } @else if (upload.status === 'started' || upload.status === 'waiting') {
              <app-circle-progress-bar
                [progress]="upload | uploadProgress: uploadSpeed() : concurrency()"
                [slowTransition]="true"
                [size]="25"
                [strokeWidth]="28"
              ></app-circle-progress-bar>
            }
          </div>
        </div>
      }
    </div>
  }
}
